module.exports = __webpack_public_path__ + "static/media/icon_chip.db8b2a84.svg";